import { render, staticRenderFns } from "./highlight.vue?vue&type=template&id=7b48fc68&scoped=true"
import script from "./highlight.vue?vue&type=script&lang=js"
export * from "./highlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b48fc68",
  null
  
)

export default component.exports